export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_7226_ALL_OPTIONS_SELECTED': 'All options selected',
    '_7213_EXPORT_DATA': 'Export Data',
    '_7207_GENERATE': 'Generate',
    '_842_N_A': 'N/A',
    '_53_NAME': 'Name',
    '_711_NO_DATA_AVAILABLE': 'No Data Available',
    '_7413_NO_RESULTS_FOUND': 'No Results Found',
    '_7206_REPORT': 'Report',
    '_994_SELECT_ALL': 'Select all',
    '_7201_SUBMIT': 'Submit',
    '_645__FIELD_LABEL__IS_A_REQUIRED_FIELD__PLEASE_SELECT_A__FIELD_LABEL_': '{{field_label}} is a required field. Please select a {{field_label}}.',
    '_59_ROLE': 'Role',
    '_75_START_DATE': 'Start Date',
    '_73_END_DATE': 'End Date',
    '_646_YYYY_MM_DD': 'yyyy-mm-dd',
    '_102_USER_NAME': 'User Name',
    '_7298_LOGIN_DATE': 'Login date',
    '_7299_TOTAL_LOGINS': 'Total Logins',
    '_965_DATE': 'Date',
    '_647_SELECT_A_ROLE': 'Select a Role',
    '_709_DATE_RANGE': 'Date Range'
};
